import { jsxs as d, jsx as n } from "react/jsx-runtime";
import { E as m, S as p } from "./icons.types-0722eef5.js";
function u({ title: i, titleId: e, size: l, width: s, height: h, extended: o = !1, ...r }) {
  const c = o ? m : p, t = l ? c[l] : s || c[o ? "s" : "l"], a = l ? c[l] : h || c[o ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      width: t,
      height: a,
      "aria-labelledby": e,
      ...r,
      children: [
        i ? /* @__PURE__ */ n("title", { id: e, children: i }) : null,
        /* @__PURE__ */ n(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M23.97 13.668c.384.113.619-.161.628-.417.01-.256-.258-.813-.517-1.13-.241-.299-.663-.68-1.345-.97l.07-3.107c0-4.338-2.649-5.315-4.857-5.531-.556-.054-2.17-.096-2.202-.095-.42.013-1.033.041-1.628.1-2.209.216-4.857 1.193-4.857 5.53l.07 3.107c-.7.29-1.13.681-1.375.983-.258.32-.526.876-.516 1.132.01.256.244.53.628.417.246-.071.59-.247.93-.42.113-.058.226-.115.334-.168l-.077 7.522-.228 1.164c-.02.118-.056.748.234 4.686.146 1.272.926 2.455 2.268 2.81.073.017 1.836.43 3.947.43l.726-.004h.008l.35-.002c1.996 0 3.7-.45 3.942-.514l.027-.008c1.342-.355 2.131-1.446 2.277-2.718.29-3.938.255-4.567.235-4.686l-.229-1.164-.076-7.52.304.154c.338.172.683.348.93.42Zm-11.212 7.643c.717.163 1.838.321 3.222.321 1.342 0 2.45-.18 3.174-.333l-.096 3.403c-.103.944-.668 1.224-1.477 1.304-.572.058-1.601.065-1.637.064a23.83 23.83 0 0 1-1.611-.072c-.808-.081-1.383-.352-1.485-1.296l-.09-3.39Zm8.701.703-.206-1.375-.13-8.548.082-4.064c-.025-2.412-.69-3.712-3.361-3.924-.756-.06-2.424-.12-3.62.005-2.665.279-3.337 1.512-3.363 3.924l.084 4.064-.13 8.548-.206 1.375c-.036.432.13 2.728.253 4.421.068.576.278 1.03.998 1.222.232.095 1.633.437 3.916.441h.027c2.592.048 4.145-.436 4.394-.537.72-.191.94-.555 1.007-1.13.125-1.694.291-3.99.255-4.422Zm-2.869-7.167.468-3.464c-.103-.65-1.441-1.164-3.095-1.164h-.015c-1.653 0-2.992.515-3.095 1.164l.469 3.475c.412-.132 1.437-.225 2.647-.225 1.179 0 2.19.088 2.621.214Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
export {
  u as VehicleTop
};
